module.exports = __webpack_public_path__ + "img/logo-22.cdc2981.jpg";